import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const newsItems = [
  {
    title: 'Solar Care International Wins Multiple Awards for Solar PV Preventive Maintenance and Innovation',
    source: 'Lanka Business News (English)',
    link: 'https://www.lankabusinessnews.com/solar-care-international-wins-multiple-awards-for-solar-pv-preventive-maintenance-and-innovation/',
    logo: '/Images/lankabusinessnews-logo.png',
    eventImages: ['/Images/image.png'],
  },
  {
    title: 'Solar Care International Wins Multiple Awards for Solar PV Preventive Maintenance and Innovation',
    source: 'LankaTalks (English)',
    link: 'https://lankatalks.com/post/solar-care-international-wins-multiple-awards-for-solar-pv-preventive-maintenance-and-innovation',
    logo: '/Images/k1vwQLKEyjDSr8imzEiKohZpvveUSw7fKzNTZDk5.png',
    eventImages: ['/Images/Screenshot 2025-11-10 153457.png'],
  },
  {
    title: 'Solar Care International Wins Multiple Awards for Solar PV Preventive Maintenance and Innovation',
    source: 'Ada Derana Biz (English)',
    link: 'http://bizenglish.adaderana.lk/solar-care-international-wins-multiple-awards-for-solar-pv-preventive-maintenance-and-innovation/',
    logo: '/Images/header-adaderana-biz-new-logo.png',
    eventImages: ['/Images/Screenshot 2025-11-10 160830.png'],
  },
  {
    title: 'Solar Care International Wins Multiple Awards for Solar PV Preventive Maintenance and Innovation',
    source: 'Profit Magazine (English)',
    link: 'https://profitmagazine.lk/solar-care-international-wins-multiple-awards-for-solar-pv-preventive-maintenance-and-innovation/',
    logo: '/Images/cropped-profit-1.webp',
    eventImages: ['/Images/Screenshot 2025-11-10 161013.png'],
  },
  {
    title: 'Solar Care International PV සූර්ය බල ශක්ති පද්ධති නඩත්තු හා නව්‍යකරණ සේවා වෙනුවෙන් සම්මාන දිනයි',
    source: 'Lanka Business News (සිංහල)',
    link: 'https://sinhala.lankabusinessnews.com/solar-care-international-pv-%E0%B7%83%E0%B7%96%E0%B6%BB%E0%B7%8A%E0%B6%BA-%E0%B6%B6%E0%B6%BD-%E0%B7%81%E0%B6%9A%E0%B7%8A%E0%B6%AD%E0%B7%92-%E0%B6%B4%E0%B6%AF%E0%B7%8A%E0%B6%B0%E0%B6%AD%E0%B7%92/',
    logo: '/Images/lankabusinessnews-logo.png',
    eventImages: ['/Images/Screenshot 2025-11-10 161626.png'],
  },
  {
    title: 'Solar Care International PV සූර්ය බල ශක්ති පද්ධති නඩත්තු හා නව්‍යකරණ සේවා වෙනුවෙන් සම්මාන දිනයි',
    source: 'Ada Derana Biz (සිංහල)',
    link: 'http://biz.adaderana.lk/solar-care-international-pv-%e0%b7%83%e0%b7%96%e0%b6%bb%e0%b7%8a%e0%b6%ba-%e0%b6%b6%e0%b6%bd-%e0%b7%81%e0%b6%9a%e0%b7%8a%e0%b6%ad%e0%b7%92-%e0%b6%b4%e0%b6%af%e0%b7%8a%e0%b6%b0%e0%b6%ad%e0%b7%92/',
    logo: '/Images/header-adaderana-biz-new-logo.png',
    eventImages: ['/Images/Screenshot 2025-11-10 161800.png'],
  },
  {
    title: 'Solar Care International PV සූර්ය බල ශක්ති පද්ධති නඩත්තු හා නව්‍යකරණ සේවා වෙනුවෙන් සම්මාන දිනයි',
    source: 'Profit Magazine (සිංහල)',
    link: 'https://profitmagazine.lk/solar-care-international-wins-multiple-awards-for-solar-pv-preventive-maintenance-and-innovation-2/',
    logo: '/Images/cropped-profit-1.webp',
    eventImages: ['/Images/Screenshot 2025-11-10 161951.png'],
  },
  {
    title: 'PV சூரிய சக்தி கட்டமைப்பு பராமரிப்பு மற்றும் புத்தாக்கச் சேவைகளுக்காக விருதுகளை வென்றுள்ள Solar Care International',
    source: 'Profit Magazine (தமிழ்)',
    link: 'https://profitmagazine.lk/solar-care-international-wins-multiple-awards-for-solar-pv-preventive-maintenance-and-innovation-3/',
    logo: '/Images/cropped-profit-1.webp',
    eventImages: ['/Images/Screenshot 2025-11-10 162303.png'],
  },
  {
    title: 'Solar Care International Honoured for Solar PV Preventive Maintenance and Innovation',
    source: 'The Island (English)',
    link: 'https://share.google/R9SSN9Qa13jAMuNeN',
    logo: '/Images/island-logo-lg-new.jpg',
    eventImages: ['/Images/Screenshot 2025-11-10 162612.png'],
  },
  {
    title: 'Solar Care International PV සූර්ය බල ශක්ති පද්ධති නඩත්තු හා නව්‍යකරණ සේවා වෙනුවෙන් සම්මාන දිනයි',
    source: 'Lankadeepa (සිංහල)',
    link: 'https://www.lankadeepa.lk/ft/Solar-Care-PV-%E0%B7%83%E0%B6%BB%E0%B6%BA-%E0%B6%B6%E0%B6%BD-%E0%B7%81%E0%B6%9A%E0%B6%AD-%E0%B6%B4%E0%B6%AF%E0%B6%B0%E0%B6%AD-%E0%B6%B1%E0%B6%A9%E0%B6%AD%E0%B6%AD%E0%B7%80%E0%B6%A7-%E0%B7%83%E0%B6%B8%E0%B6%B8%E0%B6%B1/9-680468',
    logo: '/Images/lankadeepa-ft-new21.jpg',
    eventImages: ['/Images/Screenshot 2025-11-10 162713.png'],
  },
];

const News = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, easing: 'ease-in-out', once: true });
  }, []);

  return (
    <div className="px-4 py-20 w-full flex flex-col items-center bg-gray-50">
      <h1
        className="text-5xl md:text-6xl font-bold text-black text-center mb-12"
        data-aos="fade-up"
      >
        News
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 max-w-7xl">
        {newsItems.map((item, index) => (
          <div
            key={index}
            className="bg-white shadow-md rounded-2xl overflow-hidden hover:shadow-xl transition-shadow duration-300 flex flex-col justify-between"
            data-aos="fade-up"
          >
            {/* Single event image (no scrollbar) */}
            {item.eventImages && item.eventImages.length > 0 && (
              <div className="bg-gray-100">
                <img
                  src={item.eventImages[0]}
                  alt="Event"
                  className="w-full h-56 object-cover rounded-t-2xl hover:scale-105 transition-transform duration-300"
                />
              </div>
            )}

            {/* Text content */}
            <div className="p-6 flex flex-col flex-grow">
              <h2 className="text-xl font-semibold mb-3 text-gray-800">
                {item.title}
              </h2>
              <p className="text-sm text-gray-600 mb-4">{item.source}</p>
              <a
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-800 font-medium mt-auto"
              >
                Read Full Article →
              </a>
            </div>

            {/* Logo section */}
            {item.logo && (
              <div className="border-t p-3 flex justify-center bg-gray-50">
                <img
                  src={item.logo}
                  alt={item.source}
                  className="h-10 object-contain"
                />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default News;
